export const CONTACT_TYPE_CLASSES: Record<string, string> = {
  mobile: 'border-transparent bg-blue-100 text-blue-700 dark:bg-blue-900/40 dark:text-blue-300',
  home:   'border-transparent bg-green-100 text-green-700 dark:bg-green-900/40 dark:text-green-300',
  work:   'border-transparent bg-amber-100 text-amber-700 dark:bg-amber-900/40 dark:text-amber-300',
}
